import styled from 'styled-components'
import Section1Bg from '../../static/images/karir/karir-section-1-bg.svg'
import Section5Bg from '../../static/images/karir/section-5-bg.svg'

export const KarirStyle = styled.div`
  .karir-page-main-wrapper {
    padding-top: 80px;
  }

  .section-1 {
    padding: 20px 10%;
    background: url(${Section1Bg}) no-repeat;
    background-size: contain;
    margin: 0 0 85px 0;

    .section-1-left {
      width: 50%;
      display: inline-block;

      .section-1-title {
        font-size: 32px;
        font-weight: bold;
        color: #5f77c0;
        margin: 0 0 20px 0;
      }

      .section-1-desc {
        font-size: 24px;
        color: #5f77c0;
        margin: 0 0 30px 0;
      }

      .section-1-desc-2 {
        padding: 24px 32px;
        font-size: 18px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.61;
        letter-spacing: normal;
        color: #888888;
        border-radius: 6px;
        box-shadow: 0 13px 20px 0 rgba(95, 119, 191, 0.3);
        background: #ffffff;
      }
    }

    .section-1-right {
      width: 50%;
      display: inline-block;
    }
  }

  .section-2 {
    background: #cbe1fe;
    padding: 40px 10%;
    margin-bottom: 60px;
    width: 100%;
    position: relative;

    .section-2-top-left {
      position: absolute;
      top: 0;
      left: 0;
    }

    .section-2-bottom-right {
      position: absolute;
      bottom: 0;
      right: 0;
    }

    .section-2-text-1 {
      font-size: 32px;
      color: #5f77c0;
      margin: 0 0 20px 0;
      font-weight: bold;
      z-index: 1;
    }

    .section-2-text-2 {
      font-size: 24px;
      color: #5f77c0;
      margin: 0 0 20px 0;
      width: 100%;
      z-index: 1;
    }

    a {
      border-radius: 5px;
      background: #ffffff;
      padding: 15px 20px;
      color: #ff7c00;
      text-decoration: none;
      z-index: 1;
    }
  }

  .section-3 {
    padding: 40px 10%;

    .section-3-left {
      width: 421px;
      display: inline-block;
    }

    .section-3-right {
      width: calc(100% - 421px);
      padding-left: 30px;
      display: inline-block;

      .section-3-title {
        font-size: 28px;
        font-weight: bold;
        color: #5f77c0;
        margin: 0;
      }

      .section-3-bottom-line {
        width: 70px;
        height: 8px;
        background-image: linear-gradient(to left, #ffd192, #ff8e30);
        border-radius: 6.5px;
        margin: 15px 0 30px;
      }

      .section-3-desc {
        font-size: 18px;
        margin: 0;
        color: #5f77c0;
      }
    }
  }

  .section-4 {
    padding: 40px 10%;

    .section-4-right {
      width: 421px;
      display: inline-block;
    }

    .section-4-left {
      width: calc(100% - 421px);
      padding-left: 30px;
      display: inline-block;

      .section-4-title {
        font-size: 28px;
        font-weight: bold;
        color: #5f77c0;
        margin: 0;
      }

      .section-4-bottom-line {
        width: 70px;
        height: 8px;
        background-image: linear-gradient(to left, #ffd192, #ff8e30);
        border-radius: 6.5px;
        margin: 15px 0 30px;
      }

      .section-4-desc {
        font-size: 18px;
        margin: 0;
        color: #5f77c0;
      }
    }
  }

  .section-5 {
    position: relative;
    color: #ffffff;

    .section-5-left {
      padding: 20px 10%;
      background: url(${Section5Bg}) no-repeat;
      background-size: cover;
      margin: 0 0 85px 0;
      width: 50%;
      display: inline-block;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;

      .section-5-title {
        font-size: 30px;
        font-weight: bold;
        color: #ffffff;
      }

      .section-5-desc {
        font-size: 18px;
        color: #ffffff;
      }
    }

    .section-5-right {
      width: 55%;
      position: absolute;
      right: 0;
      top: 30px;
      color: #555555;

      .section-5-card {
        padding: 25px 20px;
        border-radius: 5px;
        box-shadow: 0 10px 10px 0 rgba(143, 116, 255, 0.05);
        border: solid 1px #e3dbff;
        width: 355px;
        display: inline-block;
        margin-right: 10px;
        vertical-align: top;
        background: #ffffff;
        height: 347px;

        .section-5-card-top {
          position: relative;
          margin: 0 0 15px 0;
          font-size: 18px;
          font-weight: bold;
          color: #333333;
          line-height: 1;
          padding: 18px 0 18px 70px;

          img {
            width: 50px;
            position: absolute;
            top: 0;
            left: 0;
          }
        }

        .section-5-card-bottom {
          font-size: 14px;
          line-height: 1.57;
          color: #555555;
        }
      }
    }
  }

  .section-6 {
    padding: 15px 10% 0;

    .section-6-title {
      font-size: 30px;
      font-weight: bold;
      margin: 0 0 20px 0;
      color: #333333;
      text-align: center;
      width: 100%;
    }

    .section-6-subtitle {
      font-size: 18px;
      text-align: center;
      color: #333333;
      margin: 0 0 50px 0;
      width: 100%;
    }

    .section-6-card {
      text-align: center;
      padding: 24px 45px 40px;
      margin-right: 25px;
      box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.1);
      border: solid 1px #ffe8d0;
      border-radius: 20px;
      width: calc((100% / 3) - (50px / 3));
      vertical-align: top;

      &:nth-last-child(1) {
        margin-right: 0;
      }

      img {
        width: 164px;
        height: 164px;
        margin-bottom: 30px;
      }

      .section-6-card-title {
        font-size: 24px;
        font-weight: 600;
        color: #ff7400;
        margin: 0 0 25px 0;
      }

      .section-6-card-desc {
        font-size: 18px;
        line-height: 1.61;
        color: #888888;
        margin: 0;
      }
    }
  }

  .mob-hide {
    display: none !important;
  }

  @media screen and (min-width: 300px) and (max-width: 1024px) {
    .mob-hide {
      display: block !important;
    }

    .mob-hide-force {
      display: none !important;
    }

    .karir-page-main-wrapper {
      padding-top: 55px;
    }

    .section-1 {
      background: unset;
      padding: 0;
      margin-top: -25px;
      margin-bottom: 40px;
    }

    .section-1-left {
      width: 100% !important;
      padding: 24px 12px;
    }

    .section-1-right {
      &.mob-hide {
        width: 100% !important;
        background: url(${Section1Bg}) no-repeat;
        background-size: contain;

        img {
          width: 100%;
        }
      }
    }

    .section-2 {
    }

    .section-3 {
      padding: 0 22px;

      .section-3-left {
        width: 100%;

        img {
          width: 100%;
        }
      }

      .section-3-right {
        width: 100%;
        padding-left: 0;
      }
    }

    .section-4 {
      padding: 50px 22px;

      .section-4-left {
        width: 100%;
        padding-left: 0;
      }

      .section-4-right {
        width: 100%;

        img {
          width: 100%;
        }
      }
    }

    .section-5 {
      width: 100%;

      .section-5-left {
        width: 100%;
        margin: 0;
        padding: 20px 22px;
      }

      .section-5-right {
        width: 100%;
        position: relative;
        top: -20px;
        padding-left: 22px;
        white-space: nowrap;
        overflow: auto;

        .section-5-card {
          width: 272px;
          height: unset;

          .section-5-card-bottom {
            white-space: break-spaces;
          }
        }
      }
    }

    @media screen and (max-width: 920px) {
      .section-5-right {
        display: flex;
        white-space: unset !important;
      }

      .section-5-card {
        min-width: 272px;
      }

      .section-5-card-bottom {
        white-space: unset !important;
      }

      .section-6-card {
        width: 100% !important;
        padding: 24px 20px 40px;
        margin-bottom: 25px;
      }
    }
  }
`
